import { HELP_CENTERS_MANAGEMENT_BASE_PATH } from '@helpcenter/constants';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { replace } from '@atlassian/help-center-common-util/location';

const MIGRATED_HELP_CENTER_SANDBOX_PATH = /^\/helpcenter\/test\/[^/]+(?:\/|$)/;
const MIGRATED_HELP_CENTER_REVIEW_FLAG = 'enable-help-hub-migration';

export const isMigratedHelpCenterReviewEnabled = (): boolean =>
	FeatureGates.checkGate(MIGRATED_HELP_CENTER_REVIEW_FLAG);

export const isMigratedHelpCenterReviewPath = (pathname: string): boolean =>
	MIGRATED_HELP_CENTER_SANDBOX_PATH.test(pathname);

export const buildMigratedHelpCenterEditorUrl = (input: { helpCenterId: string }): string =>
	`/helpcenter-management/${encodeURIComponent(input.helpCenterId)}/edit-hub`;

export const leaveMigratedHelpCenterReview = (): void => {
	replace(HELP_CENTERS_MANAGEMENT_BASE_PATH);
};
